import { render, staticRenderFns } from "./DeliverEdit.vue?vue&type=template&id=0b64ccb4&scoped=true"
import script from "./DeliverEdit.vue?vue&type=script&lang=js"
export * from "./DeliverEdit.vue?vue&type=script&lang=js"
import style0 from "./DeliverEdit.vue?vue&type=style&index=0&id=0b64ccb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b64ccb4",
  null
  
)

export default component.exports